import React from "react";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { Tooltip } from "@mui/material";

const ActionDownload = React.memo<ActionClickIconProps>(({ handleClick }) => {
  return (
    <Tooltip title="Download" placement="top">
      <FileDownloadOutlinedIcon
        style={{ margin: 3, cursor: "pointer" }}
        className="icon-hover"
        onClick={handleClick}
        color="primary"
      />
    </Tooltip>
  );
});

export default ActionDownload;
